import React, { useState } from "react";
import "./HelpButtonMenu.scss";
import chevronDown from "../../assets/images/chevron-down.svg";
import BugReportIFrame from "../BugReport/BugReport";

const HelpButtonMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  // this is the button in the bottom right...

  return (
    <div>
      {/* Help Button */}
      <button
        className={`help-button ${isOpen ? "hidden" : ""}`}
        onClick={toggleMenu}
      >
        Need Help?
      </button>

      {/* Help Menu */}
      <div className={`help-menu ${isOpen ? "open" : ""}`}>
        <button className="close-button" onClick={closeMenu}>
          <img src={chevronDown} alt="Close Menu" />
        </button>
        <h3>Contact Us</h3>
        <ul>
          <li>
            Proposal Helpline:
            <br />
            <a href={`tel:${"+14353346097"}`}>&#40;435&#41; 334-6097</a>
          </li>
          <li>
            Text Sales Support:
            <br />
            <a href={`tel:${"+14353346079"}`}>&#40;435&#41; 334-6079</a>
          </li>
          <li>
            <br />
            <BugReportIFrame />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default HelpButtonMenu;
